import { ubbDecode } from './lib';
import { trim, mul } from './bll';

/**
 * 清除html 标签
 * @param {*} str
 * @param {*} isDelUbb 清理ubb码
 */
const tagDel = (str, isDelUbb) => {
  if (str) {
    if (isDelUbb) {
      str = ubbDecode(str);
      //   // 去除行尾空白
      //   str = str.replace(/[ | ]*\n/g, '\n');
      //   // 去除多余空行
      //   // str = str.replace(/\n[\s| | ]*\r/g,'\n');
      //   // 去掉ubb &nbsp;
      str = str.replace(/&nbsp;/gi, '');
      //   str = str.replace(/&lt;/ig, '');
      //   str = str.replace(/&gt;/ig, '');
      //   str = str.replace(/[div|\/div]/g, '');
      //   // 去掉替换后的<>标签
      //   str = str.replace(/&lt;[ -~]*&gt;/ig, '');
    }
    // 去除HTML.replace(/<[^>].*?>/g, "")
    str = str.replace(/<\/?[^>]*>/g, '');
  }

  return str;
};

/**
 * 根据屏幕大小动态调整显示，输出750基数20px
 * @param {*} opts 画布基础大小默认750
 * @param {*} callback 回调处理,默认更改基础字体
 */
const fontRem = (_opts, callback) => {
  _opts = _opts || {};

  let opts = {
    /** 基础值 */
    size: _opts.size || 20,
    /** ui画布宽度2x */
    width: _opts.width || 750,
    base: _opts.base || 1,
    max: _opts.max || 1.2,
    min: _opts.min || 0.8,
    /** 屏幕宽度 */
    offsetWidth: _opts.offsetWidth || document.documentElement.offsetWidth
  };

  /** 缩放倍数 */
  opts._zoom = opts.zoom = _opts.zoom || opts.offsetWidth / (opts.width / 2);

  // console.log('fontRem', opts);

  if (opts.zoom < opts.min) {
    // 小于基础值
    opts._zoom = opts.min;
  } else if (opts.zoom > 1.5) {
    // 四舍五入法
    //  opts.zoom = bll.toRound(opts.zoom, 4);
    //const _ts = _font.toFixed(2) = 1.23

    opts.level = Math.floor(opts.zoom);
    // console.log('fontRem:' + opts.level, opts);
    switch (opts.level) {
      case 1:
      case 2:
        opts._zoom = opts.zoom > 1.5 ? opts.base : opts._zoom;
        break;
      case 3:
        opts._zoom = opts.zoom > 3.5 ? opts.max : opts.base;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
        opts._zoom = opts.zoom * 0.22;
        break;
      default:
        opts._zoom = opts.max;
    }
  }

  /** 输出字体大小 */
  opts.fontSize = _opts.fontSize || mul(opts.size, opts._zoom);

  //  console.log('callback', opts);

  if (callback) {
    callback(opts);
  } else {
    // 更新页面尺寸
    let _style = document.documentElement.style;
    // console.log(_font + ' | ' + _style.fontSize + ' | ' + (_style.fontSize !== _font));
    if (_style.fontSize !== opts.fontSize) {
      // 动态更新当前字体大小
      _style.fontSize = opts.fontSize + 'px';
      // console.log(_font + ' fontRem');
    }
  }
  return opts;
};

/**
 * 获取url请求参数
 * @param {*} name 参数名称
 * @param {*} url 指定地址 空默认location.href
 */
const getUrlPars = (name, url) => {
  url = url || location.href;
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        url
        // eslint-disable-next-line no-sparse-arrays
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  );
};

/**
 * postForm 请求封装直接提交
 * @param {*} url 请求地址
 * @param {*} data 请求数据
 * @param {*} opts 配置参数{blank:'_blank',display:'none'}
 * @returns {Promise} 请求成功
 */
const postForm = (url, data, opts = {}) => {
  let _form = document.createElement('form');
  _form.action = url;
  _form.method = 'post';
  if (opts.blank) {
    _form.target = opts.blank;
  }
  if (opts.display) {
    _form.style.display = opts.display;
  }
  for (var k in data) {
    let _input = document.createElement('input');
    _input.name = k;
    _input.type = 'hidden';
    _input.value = data[k];
    _form.appendChild(_input);
  }
  document.body.appendChild(_form);
  _form.submit();
  document.body.removeChild(_form);
  return true;
};

/**
 * html 全屏显示
 * @param {*} _fulls 是否全屏
 */
const fullScreen = (_fulls) => {
  let element = document.documentElement;
  if (!_fulls) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  } else {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      // IE11
      element.msRequestFullscreen();
    }
  }
};

/**
 * vue组件compile模板解包为Json
 * @param {*} text = 'vue.compile模板 html'
 * 返回{js:{all:'标签含内容'body,attr},template:{all,body,attr,version},style:{all,body,attr,lang,link}}
 */
const unpack = (text) => {
  // 返回数据
  let data = {};

  // 取出脚本
  let regexp = /<script[^>]*>([\s\S]*?)<\/script>/gi;
  let str = regexp.exec(text);
  // console.log('unpack.script', str);
  if (str) {
    // 取出js脚本
    data.js = {
      // 含标签
      all: trim(str[0]),
      // js内容
      body: trim(str[1])
    };

    // 取出组件属性
    regexp = /<script ([\S\s\t]*?)>/gi;
    let _attr = regexp.exec(str[0]);
    if (_attr && _attr[1]) {
      data.js.attr = trim(_attr[1]);
    }

    // 去除js 代码
    text = text.replace(str[0], '');

    // 重设兼容多个模板正则
    //regexp = /<template[^>]*>([\s\S]*?)<\/template>[^>]*<script[^>]*>/gi;
    // } else {
    // html模板正则
    // regexp = /<template[^>]*>([\s\S]*?)<\/template>/gi;
  }

  // 取出样式
  regexp = /<style[^>]*>([\s\S]*?)<\/style>/gi;
  str = regexp.exec(text);
  if (str) {
    data.style = {
      // 含标签
      all: trim(str[0]),
      body: trim(str[1])
    };

    // 取出样式属性
    regexp = /<style ([\S\s\t]*?)>/gi;
    let _attr = regexp.exec(str[0]);
    // console.log('html.unpack', _attr);
    if (_attr && _attr[1]) {
      // 参数集合
      data.style.attr = _attr[1];
      // 取出样式lang
      regexp = /lang="([\S\s\t]*?)"/gi;
      let _lang = regexp.exec(data.style.attr);
      // console.log('html.unpack', _lang);
      if (_lang) {
        data.style.lang = trim(_lang[1]);
        data.style.attr = trim(data.style.attr.replace(_lang[0], ''));
      }

      // 取出样式 外部连接
      regexp = /link="([\S\s\t]*?)"/gi;
      let _link = regexp.exec(data.style.attr);
      // console.log('html.unpack', _link);
      if (_link) {
        data.style.link = trim(_link[1]) || '';
        data.style.attr = trim(data.style.attr.replace(_link[0], ''));
      }
    }

    text = text.replace(str[0], '');
  }
  // regexp = /<\/template ([\S\s\t]*?)>/gi;
  // console.log(
  //   'unpack.template',
  //   text.indexOf('<template'),
  //   text.lastIndexOf('</template>'),
  //   text
  // );

  // 剩余都属于html模板正则

  // regexp = /<template[^>]*>([\s\S]*?)<\/template>/gi;
  regexp = /<template[^>]*>/;
  str = regexp.exec(text); //取出标签长度
  // console.log('unpack.template', str);
  if (text) {
    // 取出html模板
    data.template = {
      // 含标签
      all: text.substring(
        text.indexOf(str[0]),
        text.lastIndexOf('</template>') + '</template>'.length
      ),
      body: text.substring(
        text.indexOf(str[0]) + str[0].length,
        text.lastIndexOf('</template>') // + '</template>'.length
      )
    };
    // console.log('unpack.body', data.template.body);
    // 取出组件属性
    regexp = /<template ([\S\s\t]*?)>/gi;
    let _attr = regexp.exec(data.template.body);
    if (_attr && _attr[1]) {
      data.template.attr = _attr[1];

      // 输出需缓存的版本
      regexp = /ver="([\S\s\t]*?)"/gi;
      let _ver = regexp.exec(_attr[1]);
      if (_ver && _ver[1]) {
        data.version = trim(_ver[1]);
        data.template.attr = trim(data.template.attr.replace(_ver[0], ''));
      }
    }
  }

  return data;
};

/**
 * 压缩html 代码
 * @param {*} _html 代码内容
 * @param {*} ignoreCase 忽略压缩的步骤
 * {step:'保留注释',step_a:'保留<!--注释',step_b:'保留标签间换行',step_c:'保留标签间的多余空白',step_d:'保留每行代码前后空白'
 * ,step_e:'保留js代码处理;号',step_f:'保留换行'}
 */
const mini = (_html, ignoreCase) => {
  if (!_html) {
    return _html;
  }
  let _rb = _html;
  ignoreCase = ignoreCase || {};

  if (!ignoreCase.step) {
    // 不保留注释
    //g的意思是:执行全局匹配（查找所有匹配而非在找到第一个匹配后停止）
    let reg =
      /("([^\\\"]*(\\.)?)*")|('([^\\\']*(\\.)?)*')|(\/{2,}.*?(\r|\n))|(\/\*(\n|.)*?\*\/)/g;
    //  console.log('1', _html); // 打印出：原文本
    // console.log('2', _html.match(reg)); // 打印出：匹配子串
    _rb = _rb.replace(reg, function (word) {
      //  console.log('b', word);
      // 去除注释后的文本
      return /^\/{2,}/.test(word) || /^\/\*/.test(word) ? '' : word;
    });
  }

  if (!ignoreCase.step_a) {
    _rb = _rb.replace(/<!--[\s\S]*?-->/g, ''); //去除<!--注释
    // _html = _html.replace(/(\/\*[\S\s]*\*\/)/g, ''); //去除多行注释符
  }

  if (!ignoreCase.step_d) {
    //  console.log('step_d', JSON.stringify(_rb));

    // 分解成每行代码,并清除前后空格
    let _arr = _rb.split(/\n/);
    _rb = '';
    for (let i = 0; i < _arr.length; i++) {
      //清除空格
      let _str = _arr[i].trim();
      if (_str) {
        _rb += _str + '\n';
      }
      // if (_html.charAt(i) == '\n') {
      // }
    }
  }

  if (!ignoreCase.step_b) {
    //   // _html = _html.replace(/\/\/[\s\S]*?\n/g, '\n'); //去除//注释
    // reg4 = /<(img|br|hr|input)[^>]*>/gi;          //只匹配img、br、hr、input标签
    // let regx = /<*?(\n|\r)[^>]*?>/gi;
    let regx = /<*?(\n|\r)[^>]*?>/gi; //只匹配换行标签
    //  console.log('regx', _html.match(regx));// 打印出：匹配子串
    _rb = _rb.replace(regx, function (all, t) {
      //  console.log('1', all, 't', t);
      return all.replace(/\n/g, ' '); //换行替换为空格
    });
  }

  if (!ignoreCase.step_c) {
    _rb = trim(_rb.replace(/>\s+([^\s<]*)\s+</g, '>$1<')); //去除html标签间的多余空白
    //  console.log('step_c2', _rb);
  }

  if (!ignoreCase.step_e) {
    _rb = _rb.replace(/\s*;\s*/g, ';'); //js代码处理结合
    // console.log('step_e', _rb);
  }

  if (!ignoreCase.step_f) {
    _rb = _rb.replace(/\n(\s*)/g, ''); // 去换行
    //  console.log('step_f', _rb);
  }
  // _html = _html.replace(/\s+/g, ""); //空格
  // 取出脚本
  // let regexp = /\s+(?=<)|\s+$|(?<=>)\s+|<!--.+-->|[ ]+//.+\n|/\*.+\*/|\r\n|\0/gi;
  // let str = regexp.exec(text);

  //            _html = Regex.Replace(_html,"\s+(?=<)|\s+$|(?<=>)\s+|<!--.+-->|[ ]+//.+\n|/\*.+\*/|\r\n|\0", "");
  //           _html = Regex.Replace(_html, "\\s{2,}", " ");
  // var UglifyJS = require('uglify-js');
  //_html = minify(_html);
  return _rb;
};

export { tagDel, fontRem, getUrlPars, postForm, fullScreen, unpack, mini };
